import { render, staticRenderFns } from "./Informazioni.vue?vue&type=template&id=47c3a22a&scoped=true"
import script from "./Informazioni.vue?vue&type=script&lang=js"
export * from "./Informazioni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c3a22a",
  null
  
)

export default component.exports